import { Skeleton } from "../ui/skeleton";

export const SmallTableSkeleton = () => {
  return (
    <div className="flex flex-col gap-4 overflow-hidden">
      <div className="w-full rounded-2xl border border-icon p-2 bg-white h-130">
        <Skeleton className="h-full w-full" />
      </div>
    </div>
  );
};
